<template>
    <v-dialog v-model="isActive" transition="dialog-bottom-transition" persistent :fullscreen="$vuetify.breakpoint.mobile"
        width="1080px">
        <v-card>
            <v-app-bar flat color="white">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
                <v-toolbar-title>{{ titulo }}</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
                <div class="ma-5">
                    <v-expansion-panels v-model="panel" focusable>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class=" d-flex align-center text-subtitle-1 mt-1">
                                    <v-icon color="primary" class="mr-2">mdi-account-outline</v-icon>
                                    Datos de conyuge/conviviente
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                {{ tipoEstadoCivil }}
                                <FormConyuge index="1"></FormConyuge>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class=" d-flex align-center text-subtitle-1 mt-1">
                                    <v-icon color="primary" class="mr-2">mdi-card-account-details-outline</v-icon>
                                    DNI de conyuge/conviviente (frente y dorso)
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <InputArchSolo></InputArchSolo>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class=" d-flex align-center text-subtitle-1 mt-1">
                                    <v-icon color="primary" class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>

                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-card-text>
            <!--  
                            <ExpansionPanelGen :items="itemsConyuge" :dim="itemsConyuge.length" @pasoCompleto="handleValidation" />
                        -->
        </v-card>
    </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import InputFechaModal from '@/components/inputs/InputFechaModal.vue';
import FormConyuge from '@/components/forms/FormConyuge.vue';
import ExpansionPanelGen from '@/components/panels/ExpansionPanelGen.vue'
import InputArchSolo from '@/components/inputs/InputArchSolo.vue'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        InputFechaModal,
        FormConyuge,
        InputArchSolo,
        ExpansionPanelGen,
    },
    data: () => ({
        invalid: false,
        isActive: false,
        checkbox: false,
        panel: 0,
        itemDataSelected: {
            nombres: '',
            apellido: '',
            tipdoc: '',
            nrodoc: '',
            sexo: '',
            fecnacim: '',
            fecestadocivil: '',
            nacionalidad: '',
            desnacionalidad: '',
            tipnacionalidad: '',
            destipnacionalidad: '',
            tipfamiliar: '',
            destipfamiliar: '',
            fecfallecido: '',
        },

        op: 'conyuge',

        itemTipDni: ['DNI', 'CI', 'LE', 'LC', 'PAS'], // item select tipo de dni
        itemSexo: ['F', 'M', 'X'], // item select sexo


        itemsConyuge: [
            { title: 'Datos de conyuge/conviviente', icon: 'mdi-account-outline', component: 'FormConyuge', color: 'primary' },
            { title: 'DNI de conyuge/conviviente (frente y dorso)', icon: 'mdi-card-account-details-outline', component: 'InputArchGen', color: 'primary' },
            { title: 'Certificado de matrimonio/convivencia/concubinato', icon: 'mdi-file-document-multiple-outline', component: 'InputArchGen', color: 'primary' },
        ],
        tipoDocumentacion: [
            { id: '2', tramite: 'Certificado de matrimonio.' },
            { id: '6', tramite: 'Certificado de convivencia.' },
            { id: '7', tramite: 'Acta de defunción' },
            { id: '8', tramite: 'Certificado de unión convivencial.' }
        ],
    }),
    methods: {
        ...mapActions('common', ['getTiposFamiliares']),
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteFilesPre', 'deleteItemPre', 'guardarDatosConyuge']),

        cerrarDialogo() {
            //this.$emit('cerrarDialogoCony', '')
            this.isActive = false
        },
        abrirDialog() {
            this.isActive = true
        },
        actualizarFechas(fecha, tipo) {
            switch (tipo) {
                case 'fecnacim': this.itemDataSelected.fecnacim = fecha; break;
                case 'fecestadocivil': this.itemDataSelected.fecestadocivil = fecha; break;
            }
        },
        guardarConyu() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.guardarDatosConyuge(this.itemDataSelected)
                    this.isActive = false
                    //this.$emit('isCorrectForm', { valid: true, index: this.index })
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
            this.guardarDatosConyuge(this.itemDataSelected)
        },
        cagarArchivos() {
            this.addFilesPre({ file: this.files, op: this.op })
        },
        removeFile(index) {
            this.files.splice(index, 1);
            console.log(this.files)
            this.deleteItemPre({ index: index, op: this.op })
            //console.log(this.files.splice(index, 1))
            //this.deleteItem({ file: this.files.splice(index, 1), op: this.op })
        },
        onClearFileInput() {
            this.deleteFilesPre({ file: '', op: this.op })
        },
        selectNacionalidad(value) {
            console.log(value)
            this.itemDataSelected.nacionalidad = value.id
            this.itemDataSelected.desnacionalidad = value.desnacionalidad
        },
        selectTipNacionalidad(value) {
            console.log(value)
            this.itemDataSelected.tipnacionalidad = value.tna_id
            this.itemDataSelected.destipnacionalidad = value.tna_destipnac
        },
        selectTipFamiliar(value) {
            console.log(value)
            this.itemDataSelected.tipfamiliar = value.id
            this.itemDataSelected.destipfamiliar = value.desfamiliar
        },

        handleValidation(data) {
            //si los elementos del array son true
            if (data.every((index) => index == true)) {
                this.invalid = false
            }
        },

    },
    computed: {
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades', 'tiposFamiliaresPre']),
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('preafiliacion', ['fechaEstadoCivil', 'idEstadoCivil', 'addFiles', 'deleteFiles']),


        /*         tipoCertificado() {
                    return this.tipoEstadoCivil.find(item => item.id === this.tipoDocumentacion.id)
                } */
    },
    props: ['titulo', 'dim', 'tipoEstadoCivil'],
}
</script>